import { HttpParams } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { ApiCursusDetail } from "@core/api/model/api-cursus-detail";
import { ApiToetsVerplaatsMogelijkheden } from "@core/api/model/api-toets";
import { CourseDetail } from "@core/domain/course-detail";
import { PayloadForTestMovePossibilities, TestMovePossibilities } from "@core/domain/course-test";
import { ApiMappingService } from "@core/mapping/api-mapping.service";
import { GenericHttpService } from "@core/services/generic-http.service";
import { map, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class CourseService extends GenericHttpService {
  private readonly mappingService = inject(ApiMappingService);

  fetchCourse(course: string, planId: number): Observable<CourseDetail | undefined> {
    const params = new HttpParams().set("spla_id", planId).set("cursus", course);

    return this.doFetchCourse(params);
  }

  fetchCourseForYear(year: number, course: string, planId: number): Observable<CourseDetail | undefined> {
    let params = new HttpParams().set("spla_id", planId).set("cursus", course);

    if (year > 0) {
      params = params.set("collegejaar", year);
    }

    return this.doFetchCourse(params);
  }

  private doFetchCourse(params: HttpParams): Observable<CourseDetail | undefined> {
    return this.httpGet<ApiCursusDetail | undefined>("cursus", params).pipe(
      map((courseDetail) => {
        return courseDetail ? this.mappingService.toCourseDetail(courseDetail) : undefined;
      }),
    );
  }

  fetchTestMovePossibilities(payload: PayloadForTestMovePossibilities): Observable<TestMovePossibilities> {
    const url = `plan/${payload.planId}/toetsverplaatsmogelijkheden`;
    const apiPayload = this.mappingService.mapToApiPayloadForTestMovePossibilities(payload);
    return this.httpPost<ApiToetsVerplaatsMogelijkheden>(url, undefined, JSON.stringify(apiPayload)).pipe(
      map((apiMovePossibilities) => this.mappingService.mapTestMovePossibilities(apiMovePossibilities)),
    );
  }
}
